import { validate_ci } from 'ci_node';

const isText = /^[A-Z0-9 ]+$/i;
const isEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
const isMobilePhoneUY = /^09[1-9]{1}\d{6}$/;
const isPhoneUY = /^(09[1-9]{1}\d{6})|((2|4)\d{7})$/;
const isNumber = /^\d+$/;
const isSmsCode = /^[0-9]{4}$/;
const isYear = /^[0-9]{4}$/;

export function doValidation(event, fieldValidation) {
    const { type, value, checked, name } = event.target;

    const fieldValue = (type === 'checkbox') ? checked : value;

    const { required, validate, minLength, maxLength, helperText, requiredErrorText } = fieldValidation;

    let error = ''

    if (required && !fieldValue) error = requiredErrorText || 'Este valor no debería estar vacío.'
    if (minLength && value && value.length < minLength) error = `Minimum ${minLength} characters is required.`
    if (maxLength && value && value.length > maxLength) error = 'Maximum length exceeded!'
    if (validate) {
        switch (validate) {
            case 'text':
                if (value && !isText.test(value)) error = helperText || 'Este campo acepta sólo texto.'
                break

            case 'number':
                if (value && !isNumber.test(value)) error = helperText || 'Este campo acepta sólo números.'
                break

            case 'email':
                if (value && !isEmail.test(value)) error = helperText || 'La dirección de correo electrónico no es válida.'
                break

            case 'phone':
                if (value && !isPhoneUY.test(value))
                    error = helperText || 'El campo "Teléfono celular" no tiene formáto válido (ej: 099000000).'
                break

            case 'mobile':
                if (value && !isMobilePhoneUY.test(value))
                    error = helperText || 'El campo "Teléfono celular" no tiene formáto válido (ej: 099000000).'
                break

            case 'ci':
                if (value && !validate_ci(value)) error = helperText || 'El campo "Cédula de Identidad" no es válido.'
                break

            case 'checkbox':
                if (!checked) error = helperText || 'Por favor seleccioná un valor.'
                break

            case 'select':
                if (value == null) error = helperText || 'Por favor seleccioná un valor.'
                break

            case 'dateBirth':
                if (value && !isDateBirth(value)) error = helperText || 'La fecha no es válida.'
                break

            case 'date':
                if (value && !isDDMMYYYY(value)) error = helperText || 'La fecha no es válida.'
                break

            case 'smsCode':
                if (value && !isSmsCode.test(value)) error = helperText || 'El código SMS no es válido.'
                break

            case 'rut':
                if (value && !validateRut(value)) error = helperText || 'El RUT no es válido.'
                break

            default:
                break
        }
    }

    return error;
}

function isDateBirth(value) {
    if (!isDDMMYYYY(value)) return false;

    const [day, month, year] = value.split('/');
    if (year > new Date().getFullYear()) return false;

    return true;
}

function isDDMMYYYY(value) {
    const [day, month, year] = value.split('/');

    const monthsDays = [0, 30, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    if (month < 1 || month > 12) return false;

    if (day < 1 || day > monthsDays[parseInt(month)]) return false;

    if (!isYear.test(year)) return false;

    return true;
}

function validateRut(value) {

    if (value.length === 0) return true;
    if (value.length != 12) return false;

    if (!/^([0-9])*$/.test(value)) return false;

    let dc = value.substr(11, 1);
    let rut = value.substr(0, 11);
    let total = 0;
    let factor = 2;

    for (let i = 10; i >= 0; i--) {
        total += (factor * rut.substr(i, 1));
        factor = (factor === 9) ? 2 : ++factor;
    }

    let dv = 11 - (total % 11);

    if (dv == 11) {
        dv = 0;
    } else if (dv == 10) {
        dv = 1;
    }

    if (dv == dc) return true;

    return false;
}
